// import React, { useState, useEffect, useRef } from "react";
// import { Avatar as MuiAvatar } from "@mui/material"; // Renamed to avoid conflict if you make a custom Avatar
// import { FaBell, FaSearch, FaSignOutAlt, FaUserCircle } from "react-icons/fa"; // Using React Icons
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../Utility/AuthProvider";
// import ProfileModal from "./Modals/ProfileModal"; // Ensure path is correct
// import APICall from "../Utility/APICall"; // Ensure path is correct
// import { paths } from "../Utility/Constants"; // Ensure path is correct

// function Navbar() {
//   const { deleteJwt, user, jwt, deleteSession } = useAuth();
//   const navigate = useNavigate();
//   const [profileModalOpen, setProfileModalOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   const [checkUser, setCheckUser] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       // Only run if jwt and entity_id are available
//       if (jwt && user && user.entity_id) {
//         let fetchPath = paths.user.fetch.replace("{entity_id}", user.entity_id);
//         console.log("Dashboard Fetch: Attempting API call to path:", fetchPath);

//         try {
//           const response = await APICall(
//             "GET",
//             paths.user.fetch, // Constructed path with ID
//             undefined, // body
//             { user_id: user.entity_id }, // <<<<<< TRY THIS: params object with key 'user_id'
//             jwt
//           );
//           console.log("Dashboard Fetch: API Response:", response);
//           if (response && response.status === "success" && response.response) {
//             // Assuming APICall returns status:'success'
//             setCheckUser(response.response);
//             console.log(
//               "Dashboard Fetch: User data fetched successfully 🚩:",
//               response.response // Log the actual data received
//             );
//           } else {
//             console.error(
//               "Dashboard Fetch: API call failed or bad response:",
//               response?.message,
//               response
//             );
//           }
//         } catch (error) {
//           console.error("Dashboard Fetch: CATCH Error:", error);
//         }
//       } else {
//         console.log(
//           "Dashboard Fetch: Skipping API call - JWT or user.entity_id missing.",
//           { hasJwt: !!jwt, hasUser: !!user, entityId: user?.entity_id }
//         );
//       }
//     };

//     fetchData();
//   }, [jwt, user]); // Depend on the whole user object or user.entity_id
//   // If user object can change for other reasons, user.entity_id is more specific

//   const handleLogout = async () => {
//     try {
//       await APICall("PUT", paths.user.logout, user.entity_id, undefined, jwt);
//       // Assuming API call is successful, proceed with local logout
//       console.log(
//         "API logout successful, proceeding with actual api call logout...",
//         user.entity_id
//       );
//     } catch (error) {
//       console.error("Error during API logout:", error);
//       // Optionally notify user, but still proceed with local logout for UX
//     } finally {
//       // deleteJwt();
//       localStorage.clear(); // Be cautious with localStorage.clear() if other apps use it.
//       navigate("/"); // Or to your login page
//       setDropdownOpen(false);
//     }
//     deleteSession();
//     console.log("User logged out successfully......🏁");
//   };

//   const handleAvatarClick = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   const handleViewProfile = () => {
//     setProfileModalOpen(true);
//     setDropdownOpen(false);
//   };

//   const handleCloseProfileModal = () => {
//     setProfileModalOpen(false);
//   };

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   return (
//     // Navbar container now gets padding and flex from Layout.jsx
//     // This div focuses on items alignment within the navbar's allocated space
//     <nav className="h-full flex items-center justify-between px-4 md:px-6">
//       {/* Left Side: Search (Optional, or can be a global search trigger) */}
//       <div className="flex items-center">
//         {/* Can add a global search icon/input here if needed */}
//         {/* <button className="p-2 text-gray-600 hover:text-blue-600">
//           <FaSearch className="w-5 h-5" />
//         </button> */}
//         <p className="text-lg font-semibold text-gray-700">Dashboard</p>{" "}
//         {/* Or dynamic page title */}
//       </div>

//       {/* Right Side: Icons and User Avatar */}
//       <div className="flex items-center gap-3 md:gap-4">
//         {/* Search Input (if kept here) */}
//         <div className="relative hidden md:block">
//           <span className="absolute inset-y-0 left-0 flex items-center pl-3">
//             <FaSearch className="w-4 h-4 text-gray-400" />
//           </span>
//           <input
//             type="search" // Use type="search"
//             className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md
//                        leading-5 bg-white placeholder-gray-500 focus:outline-none
//                        focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500
//                        focus:border-blue-500 sm:text-sm shadow-sm"
//             placeholder="Search..."
//           />
//         </div>

//         {/* Notifications */}
//         <button
//           className="p-2 text-gray-500 rounded-full hover:bg-gray-200 hover:text-gray-700 focus:outline-none focus:bg-gray-200"
//           aria-label="View notifications"
//         >
//           <FaBell className="w-5 h-5" />
//           {/* Add a badge for unread notifications if you have that logic */}
//           {/* <span className="absolute top-0 right-0 block h-2 w-2 transform -translate-y-1/2 translate-x-1/2 rounded-full bg-red-500 ring-2 ring-white" /> */}
//         </button>

//         {/* User Avatar and Dropdown */}
//         <div className="relative" ref={dropdownRef}>
//           <button
//             onClick={handleAvatarClick}
//             className="flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//             aria-expanded={dropdownOpen}
//             aria-haspopup="true"
//           >
//             <MuiAvatar
//               alt={user?.name || "User"}
//               src={user?.media?.profile_picture?.url} // Use your user object structure
//               sx={{ width: 36, height: 36, bgcolor: "rgb(59 130 246)" }} // Tailwind blue-500
//             >
//               {/* Fallback to initials if no image */}
//               {!user?.media?.profile_picture?.url && user?.name ? (
//                 user.name.charAt(0).toUpperCase()
//               ) : (
//                 <FaUserCircle size={20} />
//               )}
//             </MuiAvatar>
//           </button>

//           {/* Dropdown Menu */}
//           {dropdownOpen && (
//             <div
//               className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-40"
//               role="menu"
//               aria-orientation="vertical"
//               aria-labelledby="user-menu-button"
//             >
//               <div className="px-4 py-2 text-sm text-gray-700 border-b">
//                 <p className="font-medium">{user?.name || "User Name"}</p>
//                 <p className="text-xs text-gray-500 truncate">
//                   {user?.email || "user@example.com"}
//                 </p>
//               </div>
//               <button
//                 onClick={handleViewProfile}
//                 className="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//                 role="menuitem"
//               >
//                 View Profile
//               </button>
//               {/* Add more dropdown items here e.g., Settings */}
//               <button
//                 onClick={handleLogout}
//                 className="w-full text-left block px-4 py-2 text-sm text-red-600 hover:bg-red-50 hover:text-red-700"
//                 role="menuitem"
//               >
//                 <FaSignOutAlt className="inline w-4 h-4 mr-2" />
//                 Log Out
//               </button>
//             </div>
//           )}
//         </div>
//       </div>

//       <ProfileModal
//         open={profileModalOpen}
//         onClose={handleCloseProfileModal}
//         user={user} // Pass the user object to the modal
//       />
//     </nav>
//   );
// }

// export default Navbar;

// import React, { useState, useEffect, useRef } from "react";
// import { Avatar as MuiAvatar } from "@mui/material";
// import { FaBell, FaSearch, FaSignOutAlt, FaUserCircle } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../Utility/AuthProvider";
// import ProfileModal from "./Modals/ProfileModal";
// // import LogoutModal from "./Modals/LogoutModal"; // << Import the new LogoutModal
// import LogoutModal from "../components/LogoutModal";
// import APICall from "../Utility/APICall";
// import { paths } from "../Utility/Constants";

// function Navbar() {
//   const { user, jwt, deleteSession } = useAuth(); // deleteJwt removed as deleteSession is more comprehensive
//   const navigate = useNavigate();
//   const [profileModalOpen, setProfileModalOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // State for the logout confirmation modal
//   const [logoutModalOpen, setLogoutModalOpen] = useState(false); // << NEW STATE

//   const [checkUser, setCheckUser] = useState(null); // This seems for dashboard fetch

//   // Existing useEffect for fetching user data - remains unchanged
//   useEffect(() => {
//     const fetchData = async () => {
//       if (jwt && user && user.entity_id) {
//         let fetchPath = paths.user.fetch.replace("{entity_id}", user.entity_id);
//         console.log("Dashboard Fetch: Attempting API call to path:", fetchPath);
//         try {
//           const response = await APICall(
//             "GET",
//             paths.user.fetch,
//             undefined,
//             { user_id: user.entity_id },
//             jwt
//           );
//           if (response && response.status === "success" && response.response) {
//             setCheckUser(response.response);
//           } else {
//             console.error(
//               "Dashboard Fetch: API call failed or bad response:",
//               response?.message,
//               response
//             );
//           }
//         } catch (error) {
//           console.error("Dashboard Fetch: CATCH Error:", error);
//         }
//       } else {
//         // ...
//       }
//     };
//     fetchData();
//   }, [jwt, user]);

//   // Opens the logout confirmation modal
//   const handleOpenLogoutModal = () => {
//     setDropdownOpen(false); // Close avatar dropdown
//     setLogoutModalOpen(true); // Open logout confirmation
//   };

//   // Closes the logout confirmation modal
//   const handleCancelLogout = () => {
//     setLogoutModalOpen(false);
//   };

//   // Performs the actual logout after user confirms in modal
//   const handleConfirmLogout = async () => {
//     setLogoutModalOpen(false); // Close the modal first

//     try {
//       // API Call for logout
//       // Ensure the 'body' (user?.entity_id here) is what your API expects for this PUT request.
//       // Common alternatives:
//       // 1. Empty body: APICall("PUT", paths.user.logout, undefined, undefined, jwt)
//       // 2. JSON body: APICall("PUT", paths.user.logout, { userId: user?.entity_id }, undefined, jwt)
//       // 3. ID in path: paths.user.logout.replace('{entity_id}', user?.entity_id) and body as undefined.
//       // Using your original structure for now:
//       const response = await APICall(
//         "PUT",
//         paths.user.logout,
//         user?.entity_id,
//         undefined,
//         jwt
//       );

//       console.log("API logout call initiated for user:", user?.entity_id);
//       console.log("API logout response:", response);

//       if (
//         response &&
//         response.status === "success" &&
//         response.message === "User logged out successfully"
//       ) {
//         console.log("API logout successful:", response.message);
//         // The actual clearing of cookies/session will happen in the 'finally' block
//         // to ensure it occurs even if the success message isn't perfectly matched,
//         // or if there was an error, providing a consistent local logout UX.
//       } else {
//         console.warn(
//           "API logout response was not the expected success, or API call failed. Response:",
//           response
//         );
//         // Proceed with local logout anyway as per original logic's intent.
//       }
//     } catch (error) {
//       console.error("Error during API logout:", error);
//       // Still proceed with local logout for UX consistency.
//     } finally {
//       // This block executes regardless of the try/catch outcome, ensuring local cleanup.
//       console.log("Performing local logout procedures...");
//       deleteSession(); // Clears cookies (JWT, entity_id) and AuthContext state (user, jwt)

//       // Be cautious with localStorage.clear() if other applications use it on the same domain.
//       // If only this app uses localStorage, it's fine. Otherwise, remove specific items.
//       localStorage.clear();

//       navigate("/"); // Navigate to login page or home
//       // Dropdown and logout modal are already closed.
//       console.log(
//         "Local logout complete. User session cleared. Navigated to login page. 🏁"
//       );
//     }
//   };

//   const handleAvatarClick = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   const handleViewProfile = () => {
//     setProfileModalOpen(true);
//     setDropdownOpen(false);
//   };

//   const handleCloseProfileModal = () => {
//     setProfileModalOpen(false);
//   };

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownRef]);

//   return (
//     <nav className="h-full flex items-center justify-between px-4 md:px-6">
//       {/* Left Side */}
//       <div className="flex items-center">
//         <p className="text-lg font-semibold text-gray-700">Dashboard</p>
//       </div>

//       {/* Right Side: Icons and User Avatar */}
//       <div className="flex items-center gap-3 md:gap-4">
//         {/* Search Input (if kept here) */}
//         <div className="relative hidden md:block">
//           <span className="absolute inset-y-0 left-0 flex items-center pl-3">
//             <FaSearch className="w-4 h-4 text-gray-400" />
//           </span>
//           <input
//             type="search"
//             className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md
//                        leading-5 bg-white placeholder-gray-500 focus:outline-none
//                        focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500
//                        focus:border-blue-500 sm:text-sm shadow-sm"
//             placeholder="Search..."
//           />
//         </div>

//         {/* Notifications */}
//         <button
//           className="p-2 text-gray-500 rounded-full hover:bg-gray-200 hover:text-gray-700 focus:outline-none focus:bg-gray-200"
//           aria-label="View notifications"
//         >
//           <FaBell className="w-5 h-5" />
//         </button>

//         {/* User Avatar and Dropdown */}
//         <div className="relative" ref={dropdownRef}>
//           <button
//             onClick={handleAvatarClick}
//             className="flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//             aria-expanded={dropdownOpen}
//             aria-haspopup="true"
//           >
//             <MuiAvatar
//               alt={user?.name || "User"}
//               src={user?.media?.profile_picture?.url}
//               sx={{ width: 36, height: 36, bgcolor: "rgb(59 130 246)" }}
//             >
//               {!user?.media?.profile_picture?.url && user?.name ? (
//                 user.name.charAt(0).toUpperCase()
//               ) : (
//                 <FaUserCircle size={20} />
//               )}
//             </MuiAvatar>
//           </button>

//           {dropdownOpen && (
//             <div
//               className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-40"
//               role="menu"
//               aria-orientation="vertical"
//               aria-labelledby="user-menu-button"
//             >
//               <div className="px-4 py-2 text-sm text-gray-700 border-b">
//                 <p className="font-medium">{user?.name || "User Name"}</p>
//                 <p className="text-xs text-gray-500 truncate">
//                   {user?.email || "user@example.com"}
//                 </p>
//               </div>
//               <button
//                 onClick={handleViewProfile}
//                 className="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//                 role="menuitem"
//               >
//                 View Profile
//               </button>
//               <button
//                 onClick={handleOpenLogoutModal} // << UPDATED: Calls the function to open the logout modal
//                 className="w-full text-left block px-4 py-2 text-sm text-red-600 hover:bg-red-50 hover:text-red-700"
//                 role="menuitem"
//               >
//                 <FaSignOutAlt className="inline w-4 h-4 mr-2" />
//                 Log Out
//               </button>
//             </div>
//           )}
//         </div>
//       </div>

//       <ProfileModal
//         open={profileModalOpen}
//         onClose={handleCloseProfileModal}
//         user={user}
//       />

//       {/* Render the Logout Confirmation Modal */}
//       <LogoutModal
//         open={logoutModalOpen}
//         onClose={handleCancelLogout}
//         onConfirm={handleConfirmLogout}
//       />
//     </nav>
//   );
// }

// export default Navbar;

// Navbar.js
// import React, { useState, useEffect, useRef } from "react";
// import { Avatar as MuiAvatar } from "@mui/material";
// import { FaBell, FaSearch, FaSignOutAlt, FaUserCircle } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../Utility/AuthProvider"; // Correct path
// import ProfileModal from "./Modals/ProfileModal"; // Correct path
// import LogoutModal from "../components/LogoutModal"; // Correct path as per your import
// import APICall from "../Utility/APICall"; // Correct path
// import { paths } from "../Utility/Constants"; // Correct path
// import CustomImage from "../Utility/CustomImage";

// function Navbar() {
//   const { user, jwt, deleteSession } = useAuth();
//   const navigate = useNavigate();
//   const [profileModalOpen, setProfileModalOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);
//   const [logoutModalOpen, setLogoutModalOpen] = useState(false);
//   const [checkUser, setCheckUser] = useState(null); // For dashboard fetch

//   // Existing useEffect for fetching user data - remains unchanged
//   useEffect(() => {
//     const fetchData = async () => {
//       if (jwt && user && user.entity_id) {
//         // Your existing fetch logic for checkUser
//         // For brevity, I'll keep it as is from your code
//         try {
//           const response = await APICall(
//             "GET",
//             paths.user.fetch, // Assuming paths.user.fetch is the correct base path
//             undefined,
//             { user_id: user.entity_id }, // Params for GET
//             jwt
//           );
//           if (response && response.status === "success" && response.response) {
//             setCheckUser(response.response);
//           } else {
//             console.error(
//               "Dashboard Fetch: API call failed or bad response:",
//               response?.message,
//               response
//             );
//           }
//         } catch (error) {
//           console.error("Dashboard Fetch: CATCH Error:", error);
//         }
//       }
//     };
//     if (user?.entity_id) {
//       // Ensure user and entity_id exist before fetching
//       fetchData();
//     }
//   }, [jwt, user]); // Removed checkUser from deps as it's being set here

//   const handleOpenLogoutModal = () => {
//     setDropdownOpen(false);
//     setLogoutModalOpen(true);
//   };

//   // This closes the modal if the user cancels or the modal's internal "Close" button (in error state) is clicked
//   const handleCloseLogoutModal = () => {
//     setLogoutModalOpen(false);
//   };

//   // This function is passed to the LogoutModal and is responsible for the actual logout attempt.
//   // It must throw an error on failure for the modal to display the error state.
//   const attemptLogoutAndCleanup = async () => {
//     if (!user || !user.entity_id || !jwt) {
//       console.error("Attempting logout without user, entity_id, or JWT.");
//       // Throw an error that the modal can display
//       throw new Error(
//         "User session details are missing. Cannot proceed with logout."
//       );
//     }

//     try {
//       console.log("API logout call initiated for user:", user.entity_id);
//       const response = await APICall(
//         "PUT",
//         paths.user.logout,
//         user.entity_id, // Body as per your original structure. Adjust if API expects { userId: ... }
//         undefined,
//         jwt
//       );

//       console.log("API logout response:", response);

//       if (
//         response &&
//         response.status === "success" &&
//         response.message === "User logged out successfully"
//       ) {
//         console.log("API logout successful:", response.message);

//         // Perform local cleanup ONLY on successful API logout
//         console.log("Performing local logout procedures...");
//         deleteSession(); // From AuthProvider: Clears cookies (JWT, entity_id) and AuthContext state

//         // Be cautious with localStorage.clear() if other applications use it on the same domain.
//         // If only this app uses localStorage, it's fine. Otherwise, remove specific items.
//         localStorage.clear();

//         setLogoutModalOpen(false); // Close the modal on success
//         navigate("/auth"); // Navigate to login page or home
//         console.log(
//           "Local logout complete. User session cleared. Navigated to login page. 🏁"
//         );
//         // The function resolves, modal knows it was a success (and will be closed by setLogoutModalOpen(false))
//       } else {
//         console.warn(
//           "API logout response was not the expected success, or API call failed. Response:",
//           response
//         );
//         // Throw an error that the modal can display
//         throw new Error(
//           response?.message ||
//             "Logout failed. The server returned an unexpected response."
//         );
//       }
//     } catch (error) {
//       console.error("Error during API logout attempt:", error);
//       // Re-throw the error (or a more user-friendly version) so the modal can catch it
//       // and display its error UI.
//       // If error.message is already good, just re-throw.
//       // Otherwise, you can throw new Error("A network error occurred, or the server is unavailable. Please try again.");
//       throw error; // This is crucial for the LogoutModal to switch to its error state
//     }
//     // NO 'finally' block here for local cleanup.
//     // Cleanup is now conditional upon successful API logout.
//   };

//   const handleAvatarClick = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   const handleViewProfile = () => {
//     setProfileModalOpen(true);
//     setDropdownOpen(false);
//   };

//   const handleCloseProfileModal = () => {
//     setProfileModalOpen(false);
//   };

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownOpen(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []); // dropdownRef is stable, no need to include in deps

//   return (
//     <nav className="h-full flex items-center justify-between px-4 md:px-6">
//       {/* Left Side */}
//       <div className="flex items-center">
//         <p className="text-lg font-semibold text-gray-700">Dashboard</p>
//       </div>

//       {/* Right Side: Icons and User Avatar */}
//       <div className="flex items-center gap-3 md:gap-4">
//         {/* Search Input */}
//         <div className="relative hidden md:block">
//           <span className="absolute inset-y-0 left-0 flex items-center pl-3">
//             <FaSearch className="w-4 h-4 text-gray-400" />
//           </span>
//           <input
//             type="search"
//             className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md
//                        leading-5 bg-white placeholder-gray-500 focus:outline-none
//                        focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500
//                        focus:border-blue-500 sm:text-sm shadow-sm"
//             placeholder="Search..."
//           />
//         </div>

//         {/* Notifications */}
//         <button
//           className="p-2 text-gray-500 rounded-full hover:bg-gray-200 hover:text-gray-700 focus:outline-none focus:bg-gray-200"
//           aria-label="View notifications"
//         >
//           <FaBell className="w-5 h-5" />
//         </button>

//         {/* User Avatar and Dropdown */}
//         <div className="relative" ref={dropdownRef}>
//           <button
//             onClick={handleAvatarClick}
//             className="flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//             aria-expanded={dropdownOpen}
//             aria-haspopup="true"
//           >
//             {/* CORRECTED LINE HERE */}
//             {user?.media && user?.media?.profile_picture?.location ? (
//               <CustomImage
//                 location={user?.media?.profile_picture?.location}
//                 alt={user?.name || "User"}
//                 className={
//                   "w-9 h-9 rounded-full bg-blue-500 flex items-center justify-center text-white"
//                 }
//                 fallbackIcon={<FaUserCircle size={20} />}
//                 fallbackText={
//                   user?.name ? user.name.charAt(0).toUpperCase() : "U"
//                 }
//                 fallbackTextClassName="text-white"
//                 fallbackIconClassName="text-white"
//                 width={36}
//                 height={36}
//                 style={{ width: "36px", height: "36px" }}
//                 loading="lazy"
//                 onError={(e) => {
//                   e.target.onerror = null;
//                 }}
//                 onLoad={(e) => {
//                   e.target.style.display = "block";
//                   e.target.style.opacity = "1";
//                 }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                 }}
//               />
//             ) : (
//               <MuiAvatar
//                 alt={user?.name || "User"}
//                 src={user?.media?.profile_picture?.url}
//                 sx={{ width: 36, height: 36, bgcolor: "rgb(59 130 246)" }}
//               >
//                 {!user?.media?.profile_picture?.url && user?.name ? (
//                   user.name.charAt(0).toUpperCase()
//                 ) : (
//                   <FaUserCircle size={20} />
//                 )}
//               </MuiAvatar>
//             )}
//           </button>

//           {dropdownOpen && (
//             <div
//               className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-40"
//               role="menu"
//               aria-orientation="vertical"
//               aria-labelledby="user-menu-button"
//             >
//               <div className="px-4 py-2 text-sm text-gray-700 border-b">
//                 {/* <p className="font-medium">{user?.name || "User Name"}</p> */}
//                 <p className="font-medium">
//                   {user?.first_name && user?.last_name
//                     ? `${user.first_name} ${user.last_name}`
//                     : user?.first_name
//                       ? user.first_name
//                       : user?.last_name
//                         ? user.last_name
//                         : "User Name"}
//                 </p>
//                 <p className="text-xs text-gray-500 truncate">
//                   {user?.email || "user@example.com"}
//                 </p>
//               </div>
//               <button
//                 onClick={handleViewProfile}
//                 className="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//                 role="menuitem"
//               >
//                 View Profile
//               </button>
//               <button
//                 onClick={() => {
//                   navigate("/dashboard/profile");
//                   setDropdownOpen(false);
//                 }}
//                 className="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//                 role="menuitem"
//               >
//                 Profile Settings
//               </button>
//               <button
//                 onClick={handleOpenLogoutModal}
//                 className="w-full text-left block px-4 py-2 text-sm text-red-600 hover:bg-red-50 hover:text-red-700"
//                 role="menuitem"
//               >
//                 <FaSignOutAlt className="inline w-4 h-4 mr-2" />
//                 Log Out
//               </button>
//             </div>
//           )}
//         </div>
//       </div>

//       <ProfileModal
//         open={profileModalOpen}
//         onClose={handleCloseProfileModal}
//         user={user} // Pass the full user object, or checkUser if that's more up-to-date
//       />

//       <LogoutModal
//         open={logoutModalOpen}
//         onClose={handleCloseLogoutModal} // For Cancel button or clicking outside modal
//         onConfirmLogoutAttempt={attemptLogoutAndCleanup} // Modal will await this
//       />
//     </nav>
//   );
// }

// export default Navbar;

// Updated Navbar.js - Professional Avatar Dropdown
import React, { useState, useEffect, useRef } from "react";
import { Avatar as MuiAvatar } from "@mui/material";
import {
  FaBell,
  FaSearch,
  FaSignOutAlt,
  FaUserCircle,
  FaCog,
  FaUser,
} from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../Utility/AuthProvider";
import LogoutModal from "../components/LogoutModal";
import APICall from "../Utility/APICall";
import { paths } from "../Utility/Constants";
import CustomImage from "../Utility/CustomImage";

function Navbar({ toggleSidebar, isSidebarCollapsed }) {
  const { user, jwt, deleteSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [checkUser, setCheckUser] = useState(null);

  const [pageTitle, setPageTitle] = useState("Home");

  useEffect(() => {
    const { pathname } = location;

    // This logic maps the URL path to a user-friendly title
    if (pathname.startsWith("/dashboard/my-properties")) {
      setPageTitle("Properties");
    } else if (pathname.startsWith("/dashboard/tenants-list")) {
      setPageTitle("Tenants");
    } else if (pathname.startsWith("/dashboard/payments")) {
      setPageTitle("Payments");
    } else if (pathname.startsWith("/dashboard/agreements")) {
      setPageTitle("Agreements");
    } else if (pathname.startsWith("/dashboard/reports")) {
      setPageTitle("Reports");
    } else if (pathname.startsWith("/dashboard/profile")) {
      setPageTitle("Profile Settings");
    } else if (pathname === "/dashboard") {
      setPageTitle("Home");
    }
    // Add more else-if conditions for other routes as needed
  }, [location]);

  // Existing useEffect for fetching user data
  useEffect(() => {
    const fetchData = async () => {
      if (jwt && user && user.entity_id) {
        try {
          const response = await APICall(
            "GET",
            paths.user.fetch,
            undefined,
            { user_id: user.entity_id },
            jwt
          );
          if (response && response.status === "success" && response.response) {
            setCheckUser(response.response);
          } else {
            console.error(
              "Dashboard Fetch: API call failed or bad response:",
              response?.message,
              response
            );
          }
        } catch (error) {
          console.error("Dashboard Fetch: CATCH Error:", error);
        }
      }
    };
    if (user?.entity_id) {
      fetchData();
    }
  }, [jwt, user]);

  const handleOpenLogoutModal = () => {
    setDropdownOpen(false);
    setLogoutModalOpen(true);
  };

  const handleCloseLogoutModal = () => {
    setLogoutModalOpen(false);
  };

  const attemptLogoutAndCleanup = async () => {
    if (!user || !user.entity_id || !jwt) {
      console.error("Attempting logout without user, entity_id, or JWT.");
      throw new Error(
        "User session details are missing. Cannot proceed with logout."
      );
    }

    try {
      console.log("API logout call initiated for user:", user.entity_id);
      const response = await APICall(
        "PUT",
        paths.user.logout,
        user.entity_id,
        undefined,
        jwt
      );

      console.log("API logout response:", response);

      if (
        response &&
        response.status === "success" &&
        response.message === "User logged out successfully"
      ) {
        console.log("API logout successful:", response.message);
        deleteSession();
        localStorage.clear();
        setLogoutModalOpen(false);
        navigate("/auth");
        console.log("Local logout complete. User session cleared. 🏁");
      } else {
        console.warn(
          "API logout response was not the expected success:",
          response
        );
        throw new Error(
          response?.message ||
            "Logout failed. The server returned an unexpected response."
        );
      }
    } catch (error) {
      console.error("Error during API logout attempt:", error);
      throw error;
    }
  };

  const handleAvatarClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Updated navigation functions
  const handleProfileSettings = () => {
    navigate("/dashboard/profile");
    setDropdownOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="h-full flex items-center justify-between px-4 md:px-6">
      {/* Left Side */}
      <div className="flex items-center">
        {/* <p className="text-lg font-semibold text-gray-700">Dashboard</p> */}
        {isSidebarCollapsed && (
          <p className="text-lg font-semibold text-gray-700 hidden md:block">
            {pageTitle}
          </p>
        )}
      </div>

      {/* Right Side: Icons and User Avatar */}
      <div className="flex items-center md:gap-4">
        {/* Search Input */}
        <div className="relative hidden md:block">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
            <FaSearch className="w-4 h-4 text-gray-400" />
          </span>
          <input
            type="search"
            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md
                       leading-5 bg-white placeholder-gray-500 focus:outline-none
                       focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500
                       focus:border-blue-500 sm:text-sm shadow-sm"
            placeholder="Search..."
          />
        </div>

        {/* Notifications */}
        <button
          className="p-2 text-gray-500 rounded-full hover:bg-gray-200 hover:text-gray-700 focus:outline-none focus:bg-gray-200"
          aria-label="View notifications"
        >
          <FaBell className="w-5 h-5" />
        </button>

        {/* User Avatar and Professional Dropdown */}
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={handleAvatarClick}
            className="flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 hover:ring-2 hover:ring-blue-300"
            aria-expanded={dropdownOpen}
            aria-haspopup="true"
          >
            {user?.media && user?.media?.profile_picture?.location ? (
              <CustomImage
                location={user?.media?.profile_picture?.location}
                alt={user?.name || "User"}
                className="w-9 h-9 rounded-full bg-blue-500 flex items-center justify-center text-white border-2 border-white shadow-sm"
                fallbackIcon={<FaUserCircle size={20} />}
                fallbackText={
                  user?.first_name
                    ? user.first_name.charAt(0).toUpperCase()
                    : "U"
                }
                fallbackTextClassName="text-white font-semibold"
                fallbackIconClassName="text-white"
                width={36}
                height={36}
                style={{ width: "36px", height: "36px" }}
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                }}
                onLoad={(e) => {
                  e.target.style.display = "block";
                  e.target.style.opacity = "1";
                }}
              />
            ) : (
              <MuiAvatar
                alt={user?.name || "User"}
                src={user?.media?.profile_picture?.url}
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: "rgb(59 130 246)",
                  border: "2px solid white",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
              >
                {!user?.media?.profile_picture?.url && user?.first_name ? (
                  user.first_name.charAt(0).toUpperCase()
                ) : (
                  <FaUserCircle size={20} />
                )}
              </MuiAvatar>
            )}
          </button>

          {dropdownOpen && (
            <div
              className="origin-top-right absolute right-0 mt-3 w-64 rounded-xl shadow-xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50 border border-gray-100"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="user-menu-button"
            >
              {/* User Info Header */}
              <div className="px-4 py-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0">
                    {user?.media && user?.media?.profile_picture?.location ? (
                      <CustomImage
                        location={user?.media?.profile_picture?.location}
                        alt={user?.name || "User"}
                        className="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center text-white"
                        fallbackIcon={<FaUserCircle size={24} />}
                        fallbackText={
                          user?.first_name
                            ? user.first_name.charAt(0).toUpperCase()
                            : "U"
                        }
                        fallbackTextClassName="text-white font-semibold"
                        width={48}
                        height={48}
                      />
                    ) : (
                      <MuiAvatar
                        alt={user?.name || "User"}
                        sx={{
                          width: 48,
                          height: 48,
                          bgcolor: "rgb(59 130 246)",
                        }}
                      >
                        {user?.first_name ? (
                          user.first_name.charAt(0).toUpperCase()
                        ) : (
                          <FaUserCircle size={24} />
                        )}
                      </MuiAvatar>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-900 truncate">
                      {user?.first_name && user?.last_name
                        ? `${user.first_name} ${user.last_name}`
                        : user?.first_name
                          ? user.first_name
                          : user?.last_name
                            ? user.last_name
                            : "User Name"}
                    </p>
                    <p className="text-xs text-gray-600 truncate">
                      {user?.email || user?.mobile || "user@example.com"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Menu Items */}
              <div className="py-2">
                <button
                  onClick={handleProfileSettings}
                  className="w-full flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                  role="menuitem"
                >
                  <FaUser className="w-4 h-4 mr-3 text-gray-400" />
                  <span className="font-medium">Profile Settings</span>
                </button>

                <div className="border-t border-gray-100 my-1"></div>

                <button
                  onClick={handleOpenLogoutModal}
                  className="w-full flex items-center px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors duration-200"
                  role="menuitem"
                >
                  <FaSignOutAlt className="w-4 h-4 mr-3" />
                  <span className="font-medium">Sign Out</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <LogoutModal
        open={logoutModalOpen}
        onClose={handleCloseLogoutModal}
        onConfirmLogoutAttempt={attemptLogoutAndCleanup}
      />
    </nav>
  );
}

export default Navbar;
